import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InputOptionService } from './input-option.service';
@Component({
  selector: 'app-input-option',
  templateUrl: './input-option.component.html',
  styleUrls: ['./input-option.component.scss']
})
export class InputOptionComponent implements OnInit {
  @Input() inputText; //输入文字
  @Input() placeHolder: string = null;//提示信息
  @Input() typeName: string = null;//提示信息
  @Output() InputData: any = new EventEmitter();

  public results: string[];
  constructor(
    public _inputService: InputOptionService
  ) { }

  ngOnInit() {
    // console.log("输入typeName字", this.typeName);
  }
  //联想搜索
  search(event) {
    if (this.typeName) {
      this._inputService.getThinkData(this.typeName, event.query).then(resp => {
        if (resp.success) {
          this.results = resp['data'];
        } else {
          this.results = [];
        }
      })
    } else {
      this.results = [];
    }
  }

  getInputText() {
    this.InputData.emit(this.inputText);
  }

}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/input-option/input-option.component.ts